import { useQuery } from "@tanstack/react-query";

import { applicationsPermissionsKey } from "@/hooks/apis/queries/useApplicationPermissionsQuery/constants";

import { applicationsApiHandler } from "@/services/apiHandlers/applications";
import type { IAppPermissionsResponse } from "@/services/apiHandlers/applications/types";

const useApplicationPermissionsQuery = (clientId: string) => {
  const {
    data: applicationPermissions = { id: "", redirectUri: "", scopes: [] },
    isLoading: isLoadingAppPermissions,
  } = useQuery({
    queryKey: [applicationsPermissionsKey, clientId],
    queryFn: () =>
      applicationsApiHandler.getPermissionsByAppId({
        clientId,
      }),
    select: (appPermissions: IAppPermissionsResponse) => {
      const scopes = appPermissions.scopes.reduce<string[][]>(
        (resultArray, item, index) => {
          const groupIndex = Math.floor(index / 3);

          if (!resultArray[groupIndex]) {
            resultArray[groupIndex] = [];
          }

          resultArray[groupIndex].push(item);

          return resultArray;
        },
        [],
      );

      return {
        id: appPermissions.id,
        redirectUri: appPermissions.redirect,
        scopes,
      };
    },
    enabled: Boolean(clientId),
  });

  return {
    applicationPermissions,
    isLoadingAppPermissions,
  };
};

export default useApplicationPermissionsQuery;
